import { render, staticRenderFns } from "./ActivityShare.vue?vue&type=template&id=b2f462da&scoped=true&"
import script from "./ActivityShare.vue?vue&type=script&lang=js&"
export * from "./ActivityShare.vue?vue&type=script&lang=js&"
import style0 from "./ActivityShare.vue?vue&type=style&index=0&id=b2f462da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f462da",
  null
  
)

export default component.exports